// utility for computing colors for the availability of a scheduleable entity,
// e.g. membership, user, task, team, etc.
const computeAvailabilityColors = ({
  available,
  active,
  duty,
  /* availabilityCode, */
  exception_available,
  detailed_availability = {}
}) => {
  if (!active) {
    // gray if not plannable
    return {
      color: 'gray',
      borderColor: 'gray',
      textColor: 'white'
    };
  } else if (duty && available) {
    // blue if positive duty
    return {
      color: '#5959fc',
      borderColor: 'blue',
      textColor: 'white'
    };
  } else if (duty && !available) {
    // white with blue border if negative duty
    return {
      color: 'white',
      borderColor: 'blue',
      textColor: 'black'
    };
  } else if (available) {
    // green if available
    return {
      color: 'green',
      borderColor: 'green',
      textColor: 'white'
    };
  } else if ((!available && exception_available === false) || detailed_availability.exception === false) {
    // white with red border if not available in exception schedule, but there
    // is an availability code
    return {
      color: 'white',
      borderColor: 'red',
      textColor: 'black'
    };
  }
};

export default computeAvailabilityColors;
